import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";

import "../scss/pages/courseDetail.styles.scss";

import { fetchLicenciaturaById } from "../services/licenciaturaApi";
import { mallaMetaEspanol } from "../data/mallaMeta.espanol";
import CurriculumHero from "../components/CourseDetail/CurriculumHero";
import SocialShare from "../components/CourseDetail/SocialShare";
import MallaCurricular from "../components/MallaCurricular/MallaCurricular";

function CourseDetailBackLink() {
  return (
    <div className="course-detail__back">
      <Container fluid>
        <Link to="/oferta-educativa" className="course-detail__back__link">
          <span className="course-detail__back__arrow" aria-hidden="true">
            ←
          </span>
          Regresar
        </Link>
      </Container>
    </div>
  );
}

function CourseDetail() {
  const { id } = useParams();
  const [attributes, setAttributes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError({ error: false, message: "" });
      try {
        const result = await fetchLicenciaturaById(id);
        if (!cancelled) {
          if (!result?.attributes) {
            setError({
              error: true,
              message: "No se encontró la licenciatura solicitada.",
            });
            setAttributes(null);
          } else {
            setAttributes(result.attributes);
          }
        }
      } catch (err) {
        if (!cancelled) {
          setError({
            error: true,
            message: err.message || "Error al cargar la licenciatura.",
          });
          setAttributes(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="course-detail">
        <CourseDetailBackLink />
        <section className="loading">
          <Container>
            <h6>Cargando información...</h6>
          </Container>
        </section>
      </div>
    );
  }

  if (error.error || !attributes) {
    return (
      <div className="course-detail">
        <CourseDetailBackLink />
        <section className="loading">
          <Container>
            <h6>
              {error.message ||
                "No se pudo cargar la información en este momento ⌛️"}
            </h6>
          </Container>
        </section>
      </div>
    );
  }

  const malla = attributes.MallaCurricular;
  const materias = malla?.Materias ?? [];

  return (
    <div className="course-detail">
      <CourseDetailBackLink />

      <CurriculumHero
        nombre={attributes.Nombre}
        descripcion={attributes.Descripcion}
      />

      <section className="course-detail__share-bar">
        <Container fluid>
          <SocialShare
            title={attributes.Nombre}
            text={attributes.Descripcion}
          />
        </Container>
      </section>

      <MallaCurricular
        malla={malla}
        materias={materias}
        meta={mallaMetaEspanol}
      />

      <section className="course-detail__footer-cta">
        <Container fluid>
          <Link to="/oferta-educativa">Volver a oferta educativa</Link>
        </Container>
      </section>
    </div>
  );
}

export default CourseDetail;
